import styled from 'styled-components';

export const LayoutWrapper = styled.div`
    display: flex;
    height: 100%;
    .status {
        max-width: 800px;
        @media (min-width: 800px) {
            padding-left: calc(100% - 400px);
            padding-right: calc(100% - 400px);
        }
    }
    .errorWrapper {
        margin-bottom: 2px;
    }
`

export const Wrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: ${prop => prop.center ? 'center' : 'justify-content'};
    flex-direction:column;
    height: 100%;
    box-sizing: border-box;
    padding-top: 20px;
    padding: 38px 24px 0px;
    label {
        text-align: center;
    }
    .heading {
        font-size: 24px;
        color: #00377D;
    }
    .content {
        font-size: 18px;
        color: #00377D;
        margin-bottom: 12px;
        @media (min-width: 1024px) {
            color: #565656;
            font-weight: 700
        }
    }
    .subcontent {
        font-size: 16px;
        color: #565656;
        margin-bottom: 26px;
    }
    button {
        width: 125px;
        min-height: 32px;
        max-width: 125px;
        border-radius: 48px;
        box-shadow: none;
    }
    @media (min-width: 1024px) {
        padding: 138px 24px 0px;
    }
`;

export const Logo = styled.img`
  width: 158px;
  height: 158px;
  margin-bottom: 30px;
  margin-top: 30px;
`
